<template>
  <transition name="fade" mode="out-in">
    <v-alert v-if="wasPasswordEmailSent" text type="success" dense
      >Password Reset Link Sent!</v-alert
    >
    <v-btn
      v-else
      class="white--text"
      :loading="isSendingResetLink"
      @click="sendPasswordRestLink"
      v-bind="{ ...defaultOpts, ...$attrs, ...$props }"
      >{{ title }}</v-btn
    >
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import _get from 'lodash/get'

export default {
  name: 'SendPasswordResetButton',
  props: {
    email: {
      type: String,
      require: true,
      default: null,
    },
    title: {
      type: String,
      default: 'Reset Password',
    },
  },
  components: {},
  data() {
    return {
      wasPasswordEmailSent: false,
      isSendingResetLink: false,
      defaultOpts: {
        text: true,
        block: true,
        color: 'blue darken-2',
      },
    }
  },
  methods: {
    ...mapActions('auth', ['sendPasswordResetEmail']),
    async sendPasswordRestLink() {
      this.isSendingResetLink = true
      this.wasPasswordEmailSent = false
      try {
        if (!this.email) {
          this.$emit('error', 'Please enter a valid email.')
          return
        }

        await this.sendPasswordResetEmail(this.email)
        this.wasPasswordEmailSent = true
        setTimeout(() => {
          this.wasPasswordEmailSent = false
        }, 10000)
        this.error = false
        this.$emit('success')
      } catch (error) {
        this.$emit(
          'error',
          _get(
            error,
            'response.data.message',
            'Sorry but we were unable to reset your password.'
          )
        )
      } finally {
        this.isSendingResetLink = false
      }
    }, // sendPasswordRestLink
  },
}
</script>
